
jQuery(document).ready(function ($) {
	// $(".text_container").addClass("active");

	$(document).on("scroll", onScroll);

	// Hide Header on on scroll down
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = $("header").outerHeight();

	$(window).scroll(function (event) {
		didScroll = true;
	});

	setInterval(function () {
		if (didScroll) {
			hasScrolled();
			didScroll = false;
		}
	}, 250);

	function hasScrolled() {
		var st = $(this).scrollTop();

		// Make sure they scroll more than delta
		if (Math.abs(lastScrollTop - st) <= delta) return;

		// If they scrolled down and are past the navbar, add class .nav-up.
		// This is necessary so you never see what is "behind" the navbar.
		if (st > lastScrollTop && st > navbarHeight) {
			// Scroll Down
			$("header").removeClass("header_down").addClass("header_up");
		} else {
			// Scroll Up
			if (st + $(window).height() < $(document).height()) {
				$("header").removeClass("header_up").addClass("header_down");
			}
		}

		if (st == 0) {
			$("header").removeClass("header_down");
		}

		lastScrollTop = st;
	}

	// blank click function for ios
	$("a, .btn_outline, .btn_fill").click(function () { });

	// desktop menu
	$(".lg_menu ul > li:has(ul)").addClass("has-sub");

	/* 
	$(".lg_menu ul > li > a").hover(function () {
		$(".lg_menu ul > li").removeClass("active");
		$(this).closest("li").addClass("active");
	});
	 */

	if ($(".offset_menu_trigger").length) {
		$(".offset_menu_trigger").on("click", function (e) {
			e.preventDefault();

			$(".offset_menu_holder").toggleClass("in_view");
			// $(this).toggleClass("active");
		});
	}

	// offcanvas menu trigger
	if ($(".navigation ul > li:has(ul)").length) {
		$(".navigation ul > li:has(ul)").addClass("has-dropdown");
	}

	if ($(".offcanvas_menu_trigger").length) {
		$(".offcanvas_menu_trigger").on("click", function (e) {
			e.preventDefault();

			$(".nav-wrapper").toggleClass("show-menu");
			$(".sm_offcanvas_wrapper").toggleClass("active");
		});
	}

	if ($(".js-nav-toggle").length) {
		$(".js-nav-toggle").on("click", function (e) {
			e.preventDefault();

			$(".sm_offcanvas_wrapper").toggleClass("active");
			$(".nav-wrapper").toggleClass("show-menu");
		});
	}


	if ($(".close_widget").length) {
		$(".close_widget").on("click", function (e) {
			e.preventDefault();

			$(this).next().slideToggle();
			$(this).toggleClass("active");
		});
	}

	if ($(window).width() < 1199) {
		console.log("Less than window");

		$(".menu_btn_holder >a ")
			.removeClass("offset_menu_trigger")
			.addClass("filter_overaly_trigger");

		$(".filter_overaly_trigger").on("click", function (e) {
			e.preventDefault();

			console.log("clicked!");
			// $(this).toggleClass("active");

			$(".overlay_content_holder").toggleClass("show-menu");
			$(".overlay_filter").toggleClass("active");
			$("header").toggleClass("active");
		});

		$(".cls_overlay").on("click", function (e) {
			e.preventDefault();

			$(".overlay_content_holder").removeClass("show-menu");
			$(".overlay_filter").removeClass("active");
			$("header").removeClass("active");
			$(".filter_overaly_trigger").removeClass("active");
		});

		$(".subnav_single_holder_title").on("click", function (e) {
			e.preventDefault();

			$(this).toggleClass("active");
			$(this).next().slideToggle();
		});

		$(".sm_menu > ul > li > a").click(function () {
			var checkElement = $(this).next();

			$(".sm_menu li").removeClass("active");
			$(this).closest("li").addClass("active");

			if (checkElement.is("ul.collapsein") && checkElement.is(":visible")) {
				$(this).closest("li").removeClass("active");
				checkElement.slideUp("normal");
			}

			if (checkElement.is("ul.collapsein") && !checkElement.is(":visible")) {
				$(".sm_menu ul ul.collapsein:visible").slideUp("normal");
				checkElement.slideDown("normal");
			}

			if (checkElement.is("ul.collapsein")) {
				return false;
			} else {
				return true;
			}
		});

		$(".sm_menu > ul > li:has(ul)").addClass("has-sub");
	}

	if ($(window).width() < 575) {
		$(".footer_single > .footer_single_title").on("click", function (e) {
			e.preventDefault();

			$(this).toggleClass("active");
			$(this).next().slideToggle();
		});
	}


	if ($('.portfolio_section').length) {
		var portfolioGrid = $('.portfolio_content').isotope({
			// options
			itemSelector: '.portfolio_content_item',
			layoutMode: 'fitRows'
		});

		$('.portfolio_button_group ul li:first').addClass('active');

		// filter items on button click
		$('.portfolio_button_group').on('click', 'li', function () {
			var filterValue = $(this).attr('data-filter');
			portfolioGrid.isotope({ filter: filterValue });
			$('.portfolio_button_group ul li').removeClass('active');
			$(this).addClass('active');
		});
	}



	// indus tabs
	// tabbed content
	// http://www.entheosweb.com/tutorials/css/tabs.asp
	$(".tab_content").hide();
	$(".tab_content:first").show();
	// $(".tab_content:first").addClass('current');

	/* if in tab mode */
	$("ul.tabs li").click(function () {

		$(".tab_content").hide();
		var activeTab = $(this).attr("rel");
		$("#" + activeTab).fadeIn();

		$("ul.tabs li").removeClass("active");
		$(this).addClass("active");

		$(".tab_drawer_heading").removeClass("d_active");
		$(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");
	});

	$(".tab_container").css("min-height", function () {
		return $(".tabs").outerHeight() + 50;
	});

	/* if in drawer mode */
	$(".tab_drawer_heading").click(function () {

		$(".tab_content").hide();
		var d_activeTab = $(this).attr("rel");
		$("#" + d_activeTab).fadeIn();

		$(".tab_drawer_heading").removeClass("d_active");
		$(this).addClass("d_active");

		$("ul.tabs li").removeClass("active");
		$("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
	});



	AOS.init({
		duration: 1200,
		offset: 300,
		once: true,
	});
});

// viewport function
function viewport() {
	var e = window,
		a = "inner";

	if (!("innerWidth" in window)) {
		a = "client";
		e = document.documentElement || document.body;
	}

	return { width: e[a + "Width"], height: e[a + "Height"] };
}

function onScroll(event) {
	var scrollPos = $(document).scrollTop();
	$(".product_scroll_links a").each(function () {
		var currLink = $(this);
		var refElement = $(currLink.attr("href"));
		if (
			refElement.position().top <= scrollPos &&
			refElement.position().top + refElement.height() > scrollPos
		) {
			$(".product_scroll_links ul li").removeClass("current");
			currLink.parent().addClass("current");
			$(".product_scroll_links .intro_prd").text(currLink.text()); //set text
		} else {
			currLink.parent().removeClass("current");
			// currLink.removeClass("current");
		}
	});
}
